import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import React, { Fragment, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { Toast } from "../UI/toast/Toast";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
} from "reactstrap";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import PageHeader from "../common/PageHeader";
import { PreloadState } from "../UI/preloading/PreloadState";
import { createAdvancePaymentAdmin } from "../../helpers/api/finance";
import { CurrencyContext } from "../../context/Context";
import FileUploadArea from "../common/FileUploadArea";

const CreateAdvancePayment = ({ setRedirect, setRedirectUrl }) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const activeExchangeRate = Number(curr?.value ?? 0);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    setValue,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  register("bank_id");
  register("voucher");
  register("reference");
  register("amount");

  const save = async (values) => {
    const { balance } = values;
    collapseOneOpen(false);
    try {
      const formData = new FormData();
      formData.append("condominium_id", selectedCondominium);
      formData.append("increases", 1);
      formData.append("balance", balance);
      if (activeExchangeRate) formData.append("rate", activeExchangeRate);
      if (file) formData.append("voucher", file);

      if (balance > 0 || balance != null) {
        const { code } = await createAdvancePaymentAdmin(formData);

        setRedirectUrl(`/dashboard/finance`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Saldo a favor registrado exitosamente`,
        });

        if (code === SUCCESS_RESPONSE.OK) {
          setRedirectUrl(`/dashboard/finance`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Saldo a favor registrado exitosamente, espere su aprobación.`,
          });
        }
      } else {
        Toast.fire({
          type: "error",
          title: `El monto del saldo a favor debe ser mayor a 0.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const renderForm = () => (
    <Fragment>
      <Row className="no-gutters">
          <>
            {/* <Col className='pr-lg-2 mb-3' lg={8}>
                            <Card >
                                <CardHeader>
                                    <Row>
                                        <Col>
                                            <h5 className="mb-2 mb-md-0">Detalle del saldo a favor</h5>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody className="bg-light">
                    
                                </CardBody>
                            </Card>
                        </Col> */}
            <Col className="pl-lg-2 mb-3" lg={12}>
              <Card>
                <CardBody className="bg-light">
                  <p className="mb-0 font-weight-semi-bold">Monto del saldo a favor</p>
                  <Row className="py-2">
                    <Col>
                      <NumberFormat
                        prefix={`${baseCurrency.symbol} `}
                        className="form-control"
                        name="balance"
                        id="balance"
                        onValueChange={(values) => {
                          setValue("balance", values.value);
                        }}
                        fixedDecimalScale
                        decimalScale={2}
                        thousandSeparator
                      />
                    </Col>
                  </Row>
                  <FileUploadArea
                    label="Comprobante de pago (opcional)"
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      const f = e.target.files[0];
                      if (f) {
                        setFile(f);
                        setImagePreview(URL.createObjectURL(f));
                      }
                    }}
                    preview={imagePreview}
                    fileName={file?.name}
                    onRemove={() => {
                      setFile(null);
                      setImagePreview(null);
                    }}
                  />
                  <div className="d-flex justify-content-center mt-3">
                    <ButtonIcon
                      color="falcon-default"
                      className="ml-auto px-5 mr-2"
                      onClick={() => {
                        setRedirectUrl(`/dashboard/finance`);
                        setRedirect(true);
                      }}
                      iconAlign="right"
                      transform="down-1 shrink-4"
                    >
                      Volver
                    </ButtonIcon>
                    <ButtonIcon
                      color="primary"
                      icon={faDollarSign}
                      className="px-5"
                      disabled={Object.keys(errors).length > 0}
                      onClick={handleSubmit(save)}
                      iconAlign="right"
                      transform="down-1 shrink-4"
                    >
                      Registrar saldo a favor
                    </ButtonIcon>
                  </div>
                  {/*    <ButtonIcon
                    color="primary"
                    icon={faDollarSign}
                    onClick={() => collapseOneOpen(!collapseOne)}
                    className="btn-block"
                  >
                    Registrar saldo a favor
                  </ButtonIcon> */}
                </CardBody>
              </Card>
            </Col>
          </>
      </Row>
    </Fragment>
  );

  return (
    <>
      <PageHeader
        title="Registro de saldo a favor"
        titleTag="h2"
        description={"Registra un saldo a favor."}
        className="mb-3"
        col={{ lg: 9 }}
      ></PageHeader>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-transparent shadow-none"
        onSubmit={handleSubmit(save)}
      >
        <PreloadState
          loading={isSubmitting}
          message={"Emitiendo pago por favor espere..."}
        >
          {renderForm()}
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateAdvancePayment);
